import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import useAdmin from "./useAdmin";
import LoadingView from "components/LoadingView";

const Admin = ({ fallbackPath }) => {
  const { isLoading } = useJumboAuth();
  const isAdmin = useAdmin();

  if (isLoading) {
    return <LoadingView message="Loading..." />;
  }

  return isAdmin ? <Outlet /> : <Navigate to={fallbackPath} />;
};

export default Admin;
